import React from 'react';
import { useAppDispatch } from 'hooks';
import { failLiveChat } from 'actions/live-chat';
import type { HandoffIntegrations } from 'api/types';

export const useLiveChatFailure = () => {
  const dispatch = useAppDispatch();

  const handleLiveChatFailure = React.useCallback(
    ({
      error,
      integration,
    }: {
      error: string;
      integration: HandoffIntegrations;
    }) => {
      dispatch(failLiveChat({ error, integration }));
    },
    [dispatch],
  );

  return handleLiveChatFailure;
};
